import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IDataDisplayerPagination } from "../../components/DataDisplayer/DataDisplayer";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";
import { EmptySectionModel, ISectionModel } from "./SectionsApp";
import { ISearchParam } from "../BaseApp";

interface ISectionsState {
    sections: ISectionModel[],
    selectedSections: ISectionModel[],
    searchParams: ISearchParam[],
    loading: boolean,
    pagination: IDataDisplayerPagination,
    search?: string
}

const initialState: ISectionsState = {
    sections: [],
    selectedSections: [],
    searchParams: [],
    loading: false,
    pagination: {
        count: 0,
        current_page: 0,
        total_pages: 0
    }
}

const sectionsSlice = createSlice({
    name: "sections",
    initialState,
    reducers: {
        updateAllSections: (state: ISectionsState, action: PayloadAction<Array<ISectionModel>>) => {
            state.sections = action.payload
        },
        addNewSection: (state: ISectionsState, action: PayloadAction<ISectionModel>) => {
            let sections = state.sections

            if (sections.filter(section => section.id === action.payload.id).length === 0){
                state.sections.push(action.payload)
            }

        },
        deleteSection: (state: ISectionsState, action: PayloadAction<{ id: number }>) => {
            const payload = action.payload
            
            let sections = state.sections

            sections = sections.filter(item => item.id !== payload.id)

            state.sections = sections

        },
        updateSection: (state: ISectionsState, action: PayloadAction<ISectionModel>) => {
            let sections = state.sections
            
            if (sections && sections.length > 0){
                sections.map((section) => {
                    if (section.id === action.payload.id){

                        const locationIndex = sections.findIndex(section => section.id === action.payload.id)
                        sections[locationIndex] = action.payload

                    }
                })
            }

            state.sections = sections

        },
        updateSectionsLoadingStatus: (state: ISectionsState, action: PayloadAction<{ loading: boolean }>) => {
            state.loading = action.payload.loading
        },
        updateSectionsPagination: (state: ISectionsState, action: PayloadAction<IDataDisplayerPagination>) => {
            state.pagination = action.payload
        },
        updateSectionsSearch: (state: ISectionsState, action: PayloadAction<{ search: string }>) => {
            state.search = action.payload.search
        },
        updateSectionsSearchParams: (state: ISectionsState, action: PayloadAction<ISearchParam[]>) => {
            state.searchParams = action.payload
        },
        setSelectedSections: (state: ISectionsState, action: PayloadAction<ISectionModel[]>) => {
            state.selectedSections = action.payload
        },
    }
})

/**
 * Return all sections
 */
export const useReturnAllSections = () => useSelector((state: RootState) => state.sections.sections)

/**
 * Retrun single section
 */
export const useReturnSingleSection = (id: number) => {
    const sections = useReturnAllSections()

    let section: ISectionModel = EmptySectionModel

    if (sections.length > 0){
        sections.map((singleSection) => {
            if (singleSection.id === id){
                section = singleSection
            }
        })
    }

    return section

}

export const returnSingleSection = (id: number, sections: ISectionModel[]) => {

    let section: ISectionModel = EmptySectionModel

    if (sections.length > 0){
        sections.map((singleSection) => {
            if (singleSection.id === id){
                section = singleSection
            }
        })
    }

    return section

}

/**
 * Return sections loading status
 */
export const useReturnSectionsLoadingStatus = () => useSelector((state: RootState) => state.sections.loading)

/**
 * Return sections pagination
 */
export const useReturnSectionsPagination = () => useSelector((state: RootState) => state.sections.pagination)

/**
 * Return sections search
 */
export const useReturnSectionsSearch = () => useSelector((state: RootState) => state.sections.search)

/**
 * Return sections search params
 */
export const useReturnSectionsSearchParams = () => useSelector((state: RootState) => state.sections.searchParams)

/**
 * Return selected sections
 */
export const useReturnSelectedSections = () => useSelector((state: RootState) => state.sections.selectedSections)

export const { updateAllSections, addNewSection, deleteSection, updateSection, updateSectionsLoadingStatus, updateSectionsPagination, updateSectionsSearch, updateSectionsSearchParams, setSelectedSections } = sectionsSlice.actions
export default sectionsSlice.reducer